import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {
  Button,
  Grid,
  Icon,
  Modal,
} from 'semantic-ui-react';

const DeleteModal = (props) => {
  const {
    t, tReady, closeModalAction, deleteAction, isPending, text, title, itemId, ...rest
  } = props;

  return (
    <Modal open size="tiny" {...rest}>
      <Modal.Header className="modal-header">
        {title || t('common.delete')}
      </Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <b>{text || t('common.delete-this')}</b>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Button
                floated="left"
                onClick={() => closeModalAction(itemId)}
              >
                {t('common.cancel')}
              </Button>
              <Button
                icon
                negative
                loading={isPending}
                labelPosition="left"
                floated="right"
                onClick={() => deleteAction(itemId)}
              >
                <Icon name="delete" />
                {t('common.delete')}
              </Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
    </Modal>
  );
};

DeleteModal.propTypes = {
  t: PropTypes.func.isRequired,
  tReady: PropTypes.bool.isRequired,
  closeModalAction: PropTypes.func.isRequired,
  deleteAction: PropTypes.func.isRequired,
  isPending: PropTypes.bool.isRequired,
  itemId: PropTypes.string.isRequired,
  text: PropTypes.string,
  title: PropTypes.string,
};

DeleteModal.defaultProps = {
  text: '',
  title: '',
};

export default translate()(DeleteModal);



// WEBPACK FOOTER //
// ./src/components/reusable/DeleteModal.js